import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import ListFilter from "components/ListFilter";

import { fetchClientsList } from "store/client/actions";

const ClientFilter = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { list: clientsList } = useSelector(({ clientReducer }) => clientReducer);
  const { authObject } = useSelector(({ authReducer }) => authReducer);

  useEffect(() => {
    dispatch(fetchClientsList());
  }, [dispatch]);

  const allowedClients = useMemo(() => {
    if (authObject?.isAdmin) {
      return clientsList;
    }
    
    if (authObject?.clientRoles && authObject.clientRoles.length > 0) {
      const allowedClientIds = authObject.clientRoles.map(cr => 
        cr.client?._id || cr.client
      );
      
      return clientsList.filter(client => 
        allowedClientIds.some(id => {
          const clientId = typeof client._id === 'string' ? client._id : client._id?.toString();
          const allowedId = typeof id === 'string' ? id : id?.toString();
          return clientId === allowedId;
        })
      );
    }
    
    return clientsList;
  }, [clientsList, authObject]);

  const clientsWithLabel = useMemo(() => {
    return allowedClients.map(client => ({
      ...client,
      displayLabel: `${client.code || 'N/A'} - ${client.name || 'No name'}`
    }));
  }, [allowedClients]);

  const isReadOnly = allowedClients.length === 1;

  useEffect(() => {
    const searchParams = queryString.parse(location.search);
    const hasClientId = searchParams.clientId;
    
    if (!hasClientId && allowedClients.length > 0) {
      const afabClient = allowedClients.find(client => 
        client.code && client.code.toUpperCase() === 'AFAB'
      );
      
      const clientToSelect = afabClient || allowedClients[0];
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set('clientId', clientToSelect._id);
      
      history.push({
        pathname: location.pathname,
        search: newSearchParams.toString()
      });
    }
  }, [allowedClients, location.search, history, location.pathname]);

  return (
    <ListFilter
      options={clientsWithLabel}
      filterKey={"clientId"}
      selectedLabel={"All clients"}
      unselectedLabel={"All clients"}
      labelAccessor={"displayLabel"}
      valueAccessor={"_id"}
      disabled={isReadOnly}
      showDefaultOption={false}
      style={useMemo(() => {
        const q = queryString.parse(location.search);
        const id = q.clientId;
        if (!id) return {};
        const selected = allowedClients.find(c => (typeof c._id === 'string' ? c._id : c._id?.toString()) === (typeof id === 'string' ? id : id?.toString()));
        if (!selected?.color || !/^#([0-9A-Fa-f]{6})$/.test(selected.color)) return {};
        return { borderLeft: `6px solid ${selected.color}` };
      }, [location.search, allowedClients])}
    />
  );
};

export default ClientFilter;
